import {
    Box,
    Chip,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from "@mui/material";

import { camelCaseToTitleCase } from "../../../utils";

export function LogView({ jobName, process }) {
    return (
        <>
            <DialogTitle>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                >
                    <Chip label="Logs" variant="outlined" />
                    <Box>{camelCaseToTitleCase(jobName)}</Box>
                    <Box flexGrow={1} />
                    <Typography variant="body2">{process.uuid}</Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Typography fontStyle="italic" color="text.secondary">
                    Timestamps are in UTC.
                </Typography>
                <Box
                    sx={{
                        backgroundColor: "#1e1e1e",
                        padding: 2,
                        borderRadius: 1,
                        maxHeight: "60vh",
                        overflow: "auto",
                    }}
                >
                    <Typography
                        component="pre"
                        sx={{
                            fontFamily: "Consolas, monospace",
                            color: "#d4d4d4",
                            margin: 0,
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                        }}
                    >
                        {process.log || "No logs available."}
                    </Typography>
                </Box>
            </DialogContent>
        </>
    );
}
